import { AfterViewInit, Directive, ElementRef, HostListener, Input, Renderer2 } from "@angular/core";

@Directive({
  selector: "[compactOnScroll]",
  standalone: true
})
export class CompactOnScrollDirective implements AfterViewInit {
  @Input() scrollToggleClass = "compact";
  @Input() scrollToggleOffset = 70; // header height in px

  constructor(private el: ElementRef<HTMLElement>, private renderer: Renderer2) {}

  ngAfterViewInit(): void {
    this.updatePadding();
  }

  @HostListener("window:scroll")
  onWindowScroll(): void {
    this.updatePadding();
  }

  private updatePadding(): void {
    const top = this.el.nativeElement.getBoundingClientRect().top;
    if (top <= this.scrollToggleOffset) {
      this.renderer.addClass(this.el.nativeElement, this.scrollToggleClass);
    } else {
      this.renderer.removeClass(this.el.nativeElement, this.scrollToggleClass);
    }
  }
}
